"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePendingContentForNewTab = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var usePendingContentForNewTab = function () {
    var _a, _b, _c;
    var t = (0, next_intl_1.useTranslations)('translation');
    var lang = (0, next_intl_1.useLocale)();
    var stylesRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var _a;
        stylesRef.current = {
            background: (_a = window.getComputedStyle(document.body)) === null || _a === void 0 ? void 0 : _a.background,
            textColor: document.body.style.color,
        };
    }, []);
    return "\n    <html lang={lang}>\n    <head>\n      <title>".concat(t('pendingDepositStatusTitle'), "</title>\n    </head>\n    <body style=\"background: ").concat(((_a = stylesRef.current) === null || _a === void 0 ? void 0 : _a.background) ? stylesRef.current.background : 'initial', "\">\n     <div style=\"display: flex;\n    margin: 0 auto 10px;\n    height: 100%;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    \">\n    <div>\n      <img alt=\"pending\" loading=\"eager\" width=\"112\" src=\"/img/logo.svg\"/>\n    </div>\n    <div style=\"color: ").concat(((_b = stylesRef.current) === null || _b === void 0 ? void 0 : _b.textColor) && ((_c = stylesRef.current) === null || _c === void 0 ? void 0 : _c.textColor) !== ''
        ? stylesRef.current.textColor
        : '#fff', ";\n      text-align: center;\n      margin-top: 10px;\n      font-size: 22px;\n      line-height: 27px;\n      font-family: 'Inter', 'Roboto', sans-serif;\n    \">").concat(t('pendingDepositStatusTitle'), "...\n    </div>\n</div>\n    </body>\n  </html>");
};
exports.usePendingContentForNewTab = usePendingContentForNewTab;
